'use strict';

/* *
 * The directive for compiling HTML fragment
 * */

angular.module('storyApp').directive('htmlCompile', ['$compile', function($compile) {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            scope.$watch(attrs.ngBindHtml, function(newValue, oldValue) {
                $compile(element.contents())(scope);
            });
        }
    };
}]); 


// WEBPACK FOOTER //
// ./assets/components/threethings/directives/htmlCompile.js